export default __webpack_public_path__ + "static/media/music-image.1a93f4e9.jpg";